module.exports = __webpack_public_path__ + "img/square-r.d45537cc.svg";